
import { FileType } from './types';

/**
 * Helper function to determine the file type based on its extension
 */
export function getFileType(file: File): FileType {
  const fileNameParts = file.name.split('.');
  const fileExtension = fileNameParts.pop()?.toLowerCase();

  switch (fileExtension) {
    case 'pdf':
      return "pdf";
    case 'png':
      return "png";
    case 'jpg':
      return "jpg";
    case 'jpeg':
      return "jpeg";
    case 'doc':
      return "doc";
    case 'txt':
      return "txt";
    default:
      return null;
  }
}
